import {
	headerMobileBackContainerSX,
	headerMobileBackIconSX,
	headerMobileBreadcrumbMenuIconSX,
	headerMobileBreadcrumbMenuItemLinkSX,
	headerMobileDrawerContainerSX,
	headerMobileDrawerSX,
	headerMobileOpeningHoursSX,
} from '@/components/content/Header/styles/mobileDrawer';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { PageLink, useNavigation } from '@/data/Navigation';
import { Box, Divider, Drawer, Skeleton, Stack, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useLocalization } from '@/data/Localization';
import { CenefaBrandsMobile } from '@/components/content/Header/parts/CenefaBrandsMobile';
import { SupportLinks } from '@/components/content/Header/parts/SupportLinks';
import { ActionsLinks } from '@/components/content/Header/parts/ActionsLinks';
import { BreadcrumbMenu } from '@/components/content/Header/parts/BreadcrumbMenu';
import ClearIcon from '@mui/icons-material/Clear';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const HeaderMobileDrawer: FC<{
	toggleDrawer: any;
	open: boolean;
}> = ({ toggleDrawer, open }) => {
	const { navigation } = useNavigation();
	const router = useNextRouter();
	const localization = useLocalization('Header');
	const [breadcrumbMenuPath, setBreadcrumbMenuPath] = useState<PageLink[]>([]);
	const [label, setLabel] = useState('');
	const [isContentEmpty, setIsContentEmpty] = useState(false);
	useEffect(() => {
		if (!router.asPath) return;
		toggleDrawer(false)();
	}, [router.asPath, toggleDrawer]);

	const onLabelChange = (label: any) => {
		// const normalizedLabel = label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
		const cleanedLabel = label.replace(/\s+/g, '_');
		setLabel(cleanedLabel);
	};

	return (
		<Drawer anchor="right" open={open} onClose={toggleDrawer(false)} sx={{ zIndex: 9003 }}>
			<Box sx={headerMobileDrawerContainerSX}>
				<Box sx={headerMobileDrawerSX} role="presentation">
					<Box sx={headerMobileBackContainerSX}>
						<ClearIcon sx={headerMobileBackIconSX} onClick={toggleDrawer(false)} />
					</Box>
					<BreadcrumbMenu
						items={navigation?.filter(({ url }) => !!url) || []}
						path={breadcrumbMenuPath}
						onPathChange={setBreadcrumbMenuPath}
						onLabelChange={onLabelChange}
					/>
					{breadcrumbMenuPath.length === 0 ? (
						<Box sx={headerMobileBreadcrumbMenuItemLinkSX}>
							<ContentRecommendation
								id={'DPV2_Header_Category_Temporal_Spot'}
								properties={{
									emsName: 'DPV2_Header_Category_Temporal_Spot',
								}}
								loadingElement={<Box />}
								withoutFrame={true}
								onLoad={(content) => setIsContentEmpty(!content)}
							/>
							{isContentEmpty ? null : (
								<ArrowForwardIosIcon sx={headerMobileBreadcrumbMenuIconSX} />
							)}
						</Box>
					) : null}

					{breadcrumbMenuPath.length === 0 ? (
						<>
							<Divider sx={{ mt: 1.5 }} />
							<ActionsLinks />
							<Divider />
							<SupportLinks />
							<Typography sx={headerMobileOpeningHoursSX}>
								{localization.OpeningHoursDrawer.t()}
							</Typography>
						</>
					) : null}
				</Box>
				{breadcrumbMenuPath.length === 0 ? <CenefaBrandsMobile id="header-drawer" /> : null}

				{label.length > 0 ? (
					<Box sx={{ px: '24px', pb: '24px', width: '100%', img: { height: 'auto' } }}>
						<ContentRecommendation
							key={label}
							id={`DPV2_Header_${label}`}
							properties={{
								emsName: `DPV2_Header_${label}`,
							}}
							loadingElement={
								<Stack spacing={1}>
									<Skeleton variant="rounded" width={307} height={200} />
									<Skeleton variant="rounded" width={180} height={'15px'} />
									<Skeleton variant="rounded" width={100} height={'15px'} />
								</Stack>
							}
						/>
					</Box>
				) : null}
			</Box>
		</Drawer>
	);
};
